import React from 'react';
import PropTypes from 'prop-types';
import SeoLandingPage from '@components/seo-landing-page';

const page = {
  seoTitle: 'Senior Mobile Developer in Paris | Hedi Hidouri',
  seoDescription:
    'Senior mobile developer in Paris for Android, iOS, Flutter, and Kotlin Multiplatform. I help teams ship stable mobile products faster with clean architecture and CI/CD.',
  overline: 'Senior Mobile Developer',
  heading: 'Senior Mobile Developer in Paris for high-impact product teams',
  intro: [
    'I partner with product and engineering teams that need a senior profile to deliver Android and iOS applications with production-level quality.',
    'My work covers architecture decisions, delivery acceleration, code quality, and secure implementation on business-critical journeys.',
  ],
  offerTitle: 'What I deliver',
  offerItems: [
    'Mobile architecture setup and modernization (Clean Architecture, MVVM, MVI).',
    'Android and iOS feature delivery for product roadmaps with clear ownership.',
    'Cross-platform strategy with Flutter or Kotlin Multiplatform where it makes sense.',
    'Reliable release process with CI/CD, monitoring, and quality gates.',
  ],
  outcomesTitle: 'Typical outcomes',
  outcomeItems: [
    'Faster release cycle with more predictable delivery.',
    'Reduced incident volume through stronger testing and technical foundations.',
    'Improved developer velocity with clearer module boundaries and standards.',
    'Higher confidence for scaling from MVP to large user bases.',
  ],
  primaryCta: 'Discuss Your Mobile Scope',
  secondaryCta: 'See Main Portfolio',
  secondaryCtaUrl: '/en#about',
  faqTitle: 'FAQ',
  faq: [
    {
      question: 'Do you work as a freelance senior mobile developer?',
      answer:
        'Yes. I work with product teams on freelance missions, either to lead delivery of a core mobile stream or to reinforce a critical phase.',
    },
    {
      question: 'Which stacks do you cover?',
      answer:
        'Android, iOS, Flutter, Kotlin, Swift, and Kotlin Multiplatform. I also work on mobile-oriented backend and API layers when needed.',
    },
    {
      question: 'Can you join an existing team quickly?',
      answer:
        'Yes. I usually start with a focused technical audit, align on delivery priorities, and then execute with the team in short iterations.',
    },
  ],
  relatedTitle: 'Related pages',
  relatedLinks: [
    {
      label: 'Flutter, Kotlin, and iOS consultant profile',
      url: '/en/flutter-kotlin-ios-consultant',
    },
    { label: 'Homepage and full experience', url: '/en#jobs' },
    { label: 'Contact for availability', url: '/en#contact' },
  ],
  serviceSchema: {
    name: 'Senior Mobile Developer Services',
    serviceType: 'Mobile Software Development Consulting',
  },
};

const SeniorMobileDeveloperPage = ({ location }) => (
  <SeoLandingPage location={location} language="en" page={page} />
);

SeniorMobileDeveloperPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default SeniorMobileDeveloperPage;
